import { render, staticRenderFns } from "./PersonDocumentChip.vue?vue&type=template&id=380b3750"
import script from "./PersonDocumentChip.vue?vue&type=script&lang=js"
export * from "./PersonDocumentChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports